import PIXIViewport from 'pixi-viewport';
import GameObject from '../GameObject/GameObject';
import TransformComponent from '../Component/Transform';
import Renderable from '../Component/Renderable';
import ViewportComponent from '../Component/Map/Viewport';

// Viewport patch to fix destroying viewports with "noTicker" option enabled.
PIXIViewport.prototype.removeListeners = function() {
    if (this.ticker) {
        this.ticker.remove(this.tickerFunction);
    }
    // Removing event listener twice setting useCapture as true and false seems to fix the problem.
    this.div.removeEventListener('wheel', this.wheelFunction, true);
    this.div.removeEventListener('wheel', this.wheelFunction, false);
};

export default class Viewport extends GameObject<PIXIViewport> {
    protected instantiateContainer(): void {
        this.container = new PIXIViewport({
            noTicker: true,
        });
    }

    protected onCreate(params: {}) {
        this.addComponent<ViewportComponent>(ViewportComponent, {
            drag: { wheel: false },
            decelerate: { friction: 0.9 },
            clamp: { direction: 'all' },
        });
        this.container.removeListeners();

        this.addComponent(TransformComponent, params);
        this.addComponent(Renderable, params);
    }

    public resize(screenWidth: number, screenHeight: number, worldWidth: number, worldHeight: number): void {
        this.container.resize(screenWidth, screenHeight, worldWidth, worldHeight);
    }
}
